module.exports = __webpack_public_path__ + "img/ocr3.6fe6e688.png";